module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group"
  }, [_c('v-divider', {
    staticClass: "divider"
  }), _c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Turn " + _vm._s(_vm.args.turn))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcbac8ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/events/events/turn-completed/preview.vue
// module id = 349
// module chunks = 0